import { useCallback } from "react";

import { FormType, OrganizationCountry, FormCategory } from "@simplyk/common";

import { AmplitudeEvents } from "@/constants/amplitude";
import { useAmplitude } from "@/hooks/amplitude/useAmplitude";

export const useTrackThemedFormLogoClicked = ({
  formType,
  formCategory,
  country,
  formStep,
}: {
  formType: FormType;
  formCategory: FormCategory;
  country?: OrganizationCountry;
  formStep: 1 | 2;
}) => {
  const { logAmplitudeEvent } = useAmplitude();

  return useCallback(() => {
    logAmplitudeEvent(AmplitudeEvents.LearnMoreAboutZeffyViewed, {
      form_type: formType,
      form_category: formCategory,
      organization_country: country,
      form_step: formStep === 1 ? "Step 1 - Selection" : "Step 2 - Checkout",
    });
  }, [formType, formCategory, country, formStep, logAmplitudeEvent]);
};
